import { useEffect } from "react";

// Injects the player-only PWA manifest while a /player/* page is mounted,
// and removes it again on unmount. Keeps the "Install app" capability
// scoped to just the player login/verify pages — the main admin app has no
// manifest linked at all, so it never shows an install prompt.
export default function usePlayerManifest() {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "manifest";
    link.href = "/player-manifest.json";
    document.head.appendChild(link);
    const themeMeta = document.createElement("meta");
    themeMeta.name = "theme-color";
    themeMeta.content = "#14532d";
    document.head.appendChild(themeMeta);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(themeMeta);
    };
  }, []);
}
